<template>
  <div>
    <div class="w-100" v-if="isActivatedGame" style="text-align: center">
      <apexchart v-if="!noData" :height="height" type="bar" :options="chartOptions"
                 :series="series"></apexchart>
      <span v-else>{{ $t(`texts.data.no-data-purchased`) }}</span>
    </div>
    <div v-else style="text-align: center">
      <div class="w-100">
        <span style="text-align: center">Unfortunately this chart is available only in active game mode.</span>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import {campaignTypesEnum} from '@/store/campaign/store'

export default {
  name: "DataBoughtChart",
  data: () => ({
    noData: false,
    series: [],
    chartOptions: {
      colors: [
        "#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0",
        "#3F51B5", "#546E7A", "#D4526E", "#8D5B4C", "#F86624",
        "#D7263D", "#1B998B", "#2E294E", "#F46036", "#E2C044"
      ],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true
          },
        },
        zoom: {
          enabled: true
        },
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          borderRadius: 8,
          horizontal: false,
        },
      },
      xaxis: {
        categories: [],
        title: {
          text: "Team name"
        }
      },
      yaxis: {
        title: {
          text: "Amount"
        }
      },
      title: {
        text: '',
        align: 'center'
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
    },
  }),
  computed: {
    ...mapGetters(['allPurchasedData', 'gameAllTeams', 'myOwnedActivateGames']),
    isActivatedGame() {
      return this.myOwnedActivateGames.length;
    }
  },
  props: {
    selectedRound: Number,
    height: Number
  },
  watch: {
    selectedRound: function () {
      this.reset();
      this.createChart();
      this.setTitle();
    },
    allPurchasedData: function () {
      this.reset();
      this.createChart();
    }
  },
  created() {
    this.createChart();
    this.setTitle();
  },
  methods: {
    reset: function () {
      this.series = [];
      this.chartOptions.labels = [];
      this.chartOptions.title.text = ``;
      this.chartOptions.xaxis.categories = [];
    },
    async createChart() {
      let allData = this.allPurchasedData;
      let allTeams = this.gameAllTeams;

      if (!allData || !allData.length > 0) {
        this.noData = true;
        return false;
      }

      allTeams.forEach(t => this.chartOptions.xaxis.categories.push(t.name))
      allData.forEach(oneCategory => {
        this.series.push({
          name: campaignTypesEnum[oneCategory.name],
          data: this.createChartData(allTeams, oneCategory.results)
        });
      });
    },
    createChartData: function (allTeams, results) {
      let data = [];
      allTeams.forEach(t => {
        if (results.some(r => r.teamId === t.id)) {
          let sameTypeMoreThanOnce = results.filter(r => (r.teamId === t.id && r.turn === this.selectedRound));
          data.push(sameTypeMoreThanOnce.length);
        } else {
          data.push(0);
        }
      })
      return data;
    },
    setTitle() {
      this.chartOptions = {
        ...this.chartOptions, title: {
          text: `Data products purchased in round ${this.selectedRound}`
        }
      }
    }
  }
};
</script>
